export enum EventScope {
  THIS_FRAME,
  EXPOSE_TO_MERCHANT,
}
